// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgColor from "../../../components/svg-color";

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  user: icon("ic_user"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  dashboard: icon("ic_dashboard"),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "",
    items: [
      {
        title: "Home",
        path: PATH_DASHBOARD.home.root,
      },
      // {
      //   title: "Access Control",
      //   path: PATH_DASHBOARD.AccessControl,
      // },
      {
        title: "Reports",
        path: PATH_DASHBOARD.reports,
      },
      {
        title: "Billing",
        path: PATH_DASHBOARD.assuredPayBilling,
      },
      {
        title: "Bank Accounts",
        path: PATH_DASHBOARD.BankAccounts,
      },
      {
        title: "Feedback & Support",
        path: PATH_DASHBOARD.support,
      },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  // {
  //   subheader: "management",
  //   items: [
  //     {
  //       title: "user",
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: "Four", path: PATH_DASHBOARD.user.four },
  //         { title: "Five", path: PATH_DASHBOARD.user.five },
  //         { title: "Six", path: PATH_DASHBOARD.user.six },
  //       ],
  //     },
  //   ],
  // },
];

export default navConfig;
